import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbBtnSecondaryDirective } from 'rev-shared/ui/buttons/VbBtnSecondary.Directive';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';
import { VbUiTooltipComponent } from 'rev-shared/ui/tooltip/VbUiTooltip.Component';

import { TemplateMenuComponent } from './TemplateMenu.Component';
import { TemplatePickerComponent } from './TemplatePicker.Component';

const declarations = [
	TemplateMenuComponent,
	TemplatePickerComponent
];

@NgModule({
	declarations,
	exports: declarations,
	imports: [
		BsDropdownModule,
		CommonModule,
		FormGroupAngularModule,
		FormsModule,
		TranslateModule,
		TypeaheadModule,
		ValidationAngularModule,
		ValidationModule,
		VbBtnPrimaryDirective,
		VbBtnSecondaryDirective,
		VbUiTextInputDirective,
		VbUiTooltipComponent
	]
})
export class TemplatesMenuAngularModule {}
